module.exports = __webpack_public_path__ + "9c216d3b193e15902e460883ab649f4f.svg";